import styled, { css } from 'styled-components'
import { ChipProps } from './chip.types'
import { Icon } from '../icon'

const ChipContainer = styled.div<{ isDisabled?: boolean }>`
  ${({ theme, isDisabled }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sizes.xxs};
    width: fit-content;
    max-width: 100%;
    height: ${theme.sizes[6]};
    padding: 0 ${theme.sizes.xxs};
    border-radius: ${theme.radii.interactive};
    border: 1px solid ${theme.colors.gray90};
    background: ${theme.colors.gray70};

    :hover {
      background: ${theme.colors.gray90};
    }

    :active {
      border-color: ${theme.colors.goodstack};
    }

    ${isDisabled &&
    css`
      border: none;
      background: none;

      :hover {
        background: none;
      }

      :active {
        border-color: none;
      }
    `}
  `}
`

const ChipLabel = styled.span<{ isDisabled?: boolean }>`
  ${({ theme, isDisabled }) => css`
    color: ${theme.colors.text_primary};
    font-style: normal;
    font-size: ${theme.fontSizes.bodySmall};
    line-height: ${theme.sizes[6]};
    font-weight: ${theme.fontWeights.regular};

    ${isDisabled &&
    css`
      color: ${theme.colors.gray100};
    `}
  `}
`

const ChipValue = styled.span<{ isDisabled?: boolean }>`
  ${({ theme, isDisabled }) => css`
    color: ${theme.colors.text_primary};
    font-size: ${theme.fontSizes.bodySmall};
    font-style: normal;
    font-weight: ${theme.fontWeights.medium};
    line-height: ${theme.sizes[6]};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;

    ${isDisabled &&
    css`
      color: ${theme.colors.gray100};
    `}
  `}
`

const ChipButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    border: none;
    background: transparent;
    width: fit-content;
    padding: ${theme.sizes[3]} 0;
    height: ${theme.sizes[3]};
    margin-left: ${theme.sizes.xxs};
  `}
`

const ChipAmount = styled.div<{ isDisabled?: boolean }>`
  ${({ theme, isDisabled }) => css`
    font-size: ${theme.fontSizes.caption};
    padding: 1px ${theme.sizes.xxs};
    background: ${theme.colors.primary400};
    color: ${theme.colors.white};
    border-radius: 10px;
    min-width: 12px;
    min-height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${isDisabled &&
    css`
      background: ${theme.colors.gray60};
      color: ${theme.colors.gray100};
    `}
  `}
`

export const Chip = ({
  label,
  value,
  onClick,
  testId,
  icon = 'close',
  isDisabled,
  amount,
}: ChipProps) => {
  return (
    <ChipContainer isDisabled={isDisabled} data-testid={testId}>
      {label && <ChipLabel isDisabled={isDisabled}>{label}:</ChipLabel>}
      {value && <ChipValue isDisabled={isDisabled}>{value}</ChipValue>}
      {!!amount && <ChipAmount isDisabled={isDisabled}>{amount}</ChipAmount>}
      {onClick && (
        <ChipButton
          onClick={onClick}
          disabled={isDisabled}
          data-testid={testId && `${testId}-button`}
        >
          <Icon
            name={icon}
            size={3}
            color={isDisabled ? 'gray100' : 'gray700'}
          />
        </ChipButton>
      )}
    </ChipContainer>
  )
}
